import TableBlock from "./TableBlock.svelte";
import Table from "@tiptap/extension-table";
import { SvelteNodeViewRenderer } from "svelte-tiptap";

export default Table.extend({
  draggable: true,

  addNodeView() {
    return SvelteNodeViewRenderer(TableBlock, {
      contentDOMElementTag: "table",
    });
  },
});
